import T from 'i18n-react'
import { SPEC_ORDER } from 'containers/Project/Specifications/constants'
import { getMonthDayYear, getMonthDateYearTime } from 'helpers/DateUtil'

const getCSVData = (schedulesObject) => {
    const schedules = Object.values(schedulesObject)
    const specs = SPEC_ORDER.schedule
    
    var rows = {}
    rows.header = []
    rows.header.push('Schedule Type')

    specs.forEach((scheduleType) => {
      rows[scheduleType] = []
      rows[scheduleType].push(T.translate('project.schedule.elements.' + scheduleType))
    })

    rows.createdAt = []
    rows.createdAt.push('Created At')

    rows.createdBy = []
    rows.createdBy.push('Created By')
    
    schedules.forEach((schedule, index) => {
      rows.header.push('Revision ' + (index + 1))
      Object.keys(schedule.data).forEach((key) => {
        if(schedule.data[key].enabled) {
          if (rows[key]) {
            rows[key].push(schedule.data[key].date.length > 0 ? getMonthDayYear(new Date(schedule.data[key].date), false) : '')
          }
        } else {
          rows[key].push('N/A')
        }
      })
      rows.createdAt.push(getMonthDateYearTime(new Date(schedule.createdAt)))
      rows.createdBy.push(schedule.lastUpdateUserName)
    })

    var exportArray = []
    exportArray.push(rows.header)
    specs.forEach((scheduleType) => {
        exportArray.push(rows[scheduleType])
    })
    exportArray.push(rows.createdAt)
    exportArray.push(rows.createdBy)

    return exportArray
}

export {
    getCSVData
}